import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { Avatar, Stack, Typography } from '@mui/material_modern'
import { getImageUrl } from 'services/assets'
import { trackEvent } from 'utils/tracking'
import { CHURN_ZERO_EVENTS } from 'utils/constants'

const CustomerLicenseListItem = ({ props, option }) => {
  const ref = useRef()
  const [loadImage, setLoadImage] = useState(false)
  const [imageUrl, setImageUrl] = useState(null)
  const contact = option?.contacts?.[0]

  let address = ''
  if (contact?.address1) {
    address = `${contact?.address1} ${contact?.address2} ${contact?.city} ${contact?.state}`
  } else if (contact?.location) {
    address = `${contact?.location?.address1} ${contact?.location?.address2} ${contact?.location?.city} ${contact?.location?.state}`
  }

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setLoadImage(true)
          observer.disconnect()
        }
      })
    })

    if (ref.current) {
      observer.observe(ref.current)
    }

    return () => {
      observer.disconnect()
    }
  }, [])

  const eventName = CHURN_ZERO_EVENTS.GET_S3_IMAGE
  const handleS3Error = error => {
    const errorMsg = error?.data?.error || 'There was an error getting the image'
    trackEvent({
      eventName,
      errorMsg,
    })
  }

  useEffect(() => {
    if (loadImage && contact?.licenseImage) {
      getImageUrl(contact.licenseImage)
        .then(url => {
          setImageUrl(url)
        })
        .catch(handleS3Error)
    }
  }, [loadImage, contact?.licenseImage])

  return (
    <Stack {...props} ref={ref} direction="row" alignItems="center" spacing={1}>
      <Avatar src={imageUrl} variant="rounded" />
      <Stack>
        <Typography>{option?.displayName}</Typography>
        <Typography variant="body2">{contact?.licenseNumber}</Typography>
        <Typography variant="body2">{address}</Typography>
      </Stack>
    </Stack>
  )
}

CustomerLicenseListItem.propTypes = {
  props: PropTypes.object,
  option: PropTypes.object,
}

CustomerLicenseListItem.defaultProps = {
  props: {},
  option: {},
}

export default CustomerLicenseListItem
